import React, { useState } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import ListItemComponent from '../components/Others/listItemComponent';

import WelcomeBox from '../components/Home/WelcomeBox';
import Introduction from '../components/Intro/Introduction';
import SkillsBox from '../components/Skills/SkillsBox';
import Experience from '../components/Experience/Experience';
import ContactBox from '../components/Contact/ContactBox';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';

library.add(fas);

function App() {
	const [section, setSections] = useState({
		home: true,
		intro: false,
		skills: false,
		work: false,
		contact: false,
	});

	const [classes, setClasses] = useState([
		'sideBarItem',
		'sideBarItem',
		'sideBarItem',
		'sideBarItem',
		'sideBarItem',
	]);

	const clickHandler = (id) => {
		setClasses([
			'sideBarItem',
			'sideBarItem',
			'sideBarItem',
			'sideBarItem',
			'sideBarItem',
		]);

		setClasses((prevState) => {
			const arr = prevState;
			arr.splice(id, 1, 'activeClass');
			return arr;
		});

		let temp =
			id === 1
				? {
						home: false,
						intro: true,
						skills: false,
						work: false,
						contact: false,
				  }
				: id === 2
				? {
						home: false,
						intro: false,
						skills: true,
						work: false,
						contact: false,
				  }
				: id === 3
				? {
						home: false,
						intro: false,
						skills: false,
						work: true,
						contact: false,
				  }
				: id === 4
				? {
						home: false,
						intro: false,
						skills: false,
						work: false,
						contact: true,
				  }
				: {
						home: true,
						intro: false,
						skills: false,
						work: false,
						contact: false,
				  };

		setSections(temp);
	};

	return (
		<div className='main-page'>
			{/* navbar */}
			<header>
				<Navbar className='nav-bar' fixed='top' expand='md'>
					<Navbar.Toggle aria-controls='basic-navbar-nav' />
					<Navbar.Collapse id='basic-navbar-nav'>
						<Nav className='mr-auto'>
							<h6 className='nav-link' onClick={() => clickHandler(0)}>
								Home
							</h6>
							<h6 className='nav-link' onClick={() => clickHandler(1)}>
								Who am I
							</h6>
							<h6 className='nav-link' onClick={() => clickHandler(2)}>
								What can I do
							</h6>
							<h6 className='nav-link' onClick={() => clickHandler(3)}>
								What did I do
							</h6>
							<h6 className='nav-link' onClick={() => clickHandler(4)}>
								Contact
							</h6>
						</Nav>
					</Navbar.Collapse>
				</Navbar>
			</header>

			{/* sidebar */}
			<nav id='sideBar'>
				<ul>
					<ListItemComponent
						label='Home'
						iconClass='fas fa-home'
						theClassIWant={classes[0]}
						clicked={() => clickHandler(0)}
					/>

					<ListItemComponent
						label='Who am I'
						iconClass='fas fa-user'
						theClassIWant={classes[1]}
						clicked={() => clickHandler(1)}
					/>

					<ListItemComponent
						label='what can I do'
						iconClass='fas fa-tools'
						theClassIWant={classes[2]}
						clicked={() => clickHandler(2)}
					/>

					<ListItemComponent
						label='what did I do'
						iconClass='fas fa-briefcase'
						theClassIWant={classes[3]}
						clicked={() => clickHandler(3)}
					/>

					<ListItemComponent
						label='Contact'
						iconClass='fas fa-envelope'
						theClassIWant={classes[4]}
						clicked={() => clickHandler(4)}
					/>
				</ul>
			</nav>

			{/* shown section */}
			{section.intro ? (
				<Introduction />
			) : section.skills ? (
				<SkillsBox />
			) : section.work ? (
				<Experience />
			) : section.contact ? (
				<ContactBox />
			) : (
				<WelcomeBox />
			)}
		</div>
	);
}

export default App;
